<template>
	<div>
		<notifications position="top center" group="info" />

		<h3>Tables</h3>
		<b-card v-for="(table, idx) in request.tables" :key="idx">
			<div>Table</div>

			<b-select @change="update_table(idx, false, true, $event)" v-model="table.table" :options="tables_name"></b-select>
			<div>Nom</div>
			<b-input @change="update_name($event, idx)" v-model="table.name"></b-input>
			<div v-if="idx > 0">
				<div>Jointure</div>
				<b-select v-model="table.join" :options="['left join', 'right join', 'inner join', 'full join']"></b-select>
				<div>Règles de jointures</div>
				<b-input v-model="table.join_rules"></b-input>
			</div>
			<div>Conditions</div>
			<b-input v-model="table.conditions"></b-input>
			<div :id="'builder' + table.id"></div>
			<div>Colonnes</div>	
			<b-table
				striped
				hover
				:items="table.columns"
				:fields="[
					{ key: 'select', label: 'Sélectionner' },
					{ key: 'column', label: 'Colonne' },
					{ key: 'name', label: 'Nom dans le fichier de résultats' },
					{ key: 'exemple', label: 'Exemple' }
				]">
				<template v-slot:cell(select)="row">
					<b-checkbox v-model="row.item.select" />
				</template>
				<template v-slot:cell(name)="row">
					<b-input v-model="row.item.name" />
				</template>
			</b-table>
			<b-button @click="update_table(idx, true, false, $event)"><i class="fas fa-sync-alt"></i></b-button>&nbsp;
			<b-button @click="select_column_all(idx)">Sélectionner toutes les colonnes</b-button>&nbsp;
			<b-button @click="unselect_column_all(idx)">Désélectionner toutes les colonnes</b-button>&nbsp;
			<b-button @click="add_prefix(idx)"><i class="fas fa-plus"></i> prefix</b-button>&nbsp;
			<b-button @click="remove_prefix(idx)"><i class="fas fa-minus"></i> prefix</b-button>&nbsp;
			<b-button variant="danger" @click="remove(idx)"><i class="fas fa-trash"></i></b-button>
		</b-card>
		<br />
		<b-button @click="add">Ajouter</b-button>

		<h3>Paramètres</h3>

		<div>Conditions</div>
		<b-input v-model="request.conditions"></b-input>
		<div>Selection</div>
		<b-input v-model="request.select"></b-input>
		<div>Grouper par</div>
		<b-input v-model="request.group_by"></b-input>
		<div>Ordonner par</div>
		<b-input v-model="request.order_by"></b-input>
		<div>Nombre de résultats</div>
		<b-input @change="request.offset = (request.page - 1) *request.limit" v-model="request.limit"></b-input>
		<div>Numéro de pages</div>
		<b-input @change="request.offset = (request.page - 1) *request.limit" v-model="request.page"></b-input>

		<h3>Paramètres</h3>

		<div :id="'builder-params-' + id"></div>

		<h3>Requête</h3>

		<treatment_params ref="tp"></treatment_params>

		<br />

		<b-button @click="test">Exécuter</b-button>

		<br /><br />

		<b-alert variant="danger" v-if="error" show>Erreur : {{error}}</b-alert>
		
		<edit_tabulator @data="update_data_selection" @update="update_data" v-show="data_test.length > 0" :extern_file="false" ref="tabulator"></edit_tabulator>

		<div v-show="request.sql && !minimal">{{ request.sql }}</div>
		
	</div>
</template>

<script>
	var clone = require("clone");

	import * as json2csv from "json2csv";
	import uniqueId from "lodash.uniqueid";
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	import $ from "jquery";
	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import database from "../services/database.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import treatment_params from "../components/treatment_params.vue"

	export default {
		name: "database_request",
		components: {
			edit_tabulator: edit_tabulator,
			treatment_params: treatment_params
		},
		props: {
			minimal: {
				default: false
			}
		},
		data() {
			return {
				id: uniqueId(),

				tables: [],
				tables_name: [],

				table: "",

				request: {
					tables: [],
					conditions: "",
					select: "",
					group_by: "",
					order_by: "",
					page: 1,
					offset: 0,
					limit: 1000,
					sql: ""
				},

				data_test: [],
				error: "",
				sql: ""
			};
		},
		watch: {
			data_test: {
				deep: true,
				handler() {
					this.$emit("update", this.data_test);
				},
			}
		},
		methods: {
			update_data(id, data) {
				this.data_test = data;
			},
			update_data_selection(data) {
				this.data_test = data;
			},
			get_data: function () {
				return this.data_test;
			},
			get_data_blob: async function () {
				var str_csv = json2csv.parse(this.data_test, {
					fields: Object.keys(this.data_test[0]),
					fieldNames: Object.keys(this.data_test[0]),
				});

				return new Blob([str_csv], {
					type: "text/plain",
				});
			},
			get_data_files: async function (all_files = true) {
				if (!all_files) return [];

				var str_csv = json2csv.parse(this.data_test, {
					fields: Object.keys(this.data_test[0]),
					fieldNames: Object.keys(this.data_test[0]),
				});

				return [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];
			},
			async save()
			{
				var request = clone(this.request);

				if (request.sql)
					delete request.sql;

				for (var i = 0; i < request.tables.length; i++)
				{
					for (var j = 0; j < request.tables[i].columns.length; j++)
					{
						delete request.tables[i].columns[j].exemple
					}
				}

				return {
					request
				}
			},
			async load(data)
			{
				this.request = data.request;

				for (var i = 0; i < this.request.tables.length; i++)
				{
					var lines = await database.get("SELECT", this.request.tables[i].table, {
						end: "ORDER BY id DESC LIMIT 1",
					});
					for (var j = 0; j < this.request.tables[i].columns.length; j++)
					{
						if (lines.length > 0 && lines[0].hasOwnProperty(this.request.tables[i].columns[j].column))
							this.request.tables[i].columns[j].exemple = lines[0][this.request.tables[i].columns[j].column];
					}

					await this.set_qb_table(this.request.tables[i], i, this.request.tables[i].conditions_qb || {});
				}

				if (this.request.sql)
					this.request.sql = "";

				var self = this;

				if (this.request.editor_params)
				{
					this.editor_params.setValue(this.request.editor_params);
					this.$refs.tp.set(this.request.editor_params);
				}

				this.test();
			},
			async new()
			{
				this.request = {
					tables: [],
					query_builder_conditions: [],
					free_conditions: "",
					conditions: "",
					select: "",
					group_by: "",
					order_by: "",
					page: 1,
					offset: 0,
					limit: 10
				}
			},
			async add()
			{
				this.request.tables.push({
					table: "",
					_name: "",
					name: "",
					id: uniqueId(),
					join: "left join",
					join_rules: "",
					columns: [],
					conditions: "",
					conditions_qb: {},
					conditions_qb_sql: ""
				})
			},
			async remove(idx)
			{
				this.request.tables.splice(idx, 1);
			},
			async set_qb_table(table, idx, rules = {})
			{
				var table = this.request.tables[idx];
				var self = this;

				console.log(table)

				var config = {
					filters: table.columns,
					icons: {
						add_group: "fas fa-plus-square",
						add_rule: "fas fa-plus-circle",
						remove_group: "fas fa-minus-square",
						remove_rule: "fas fa-minus-circle",
						error: "fas fa-exclamation-triangle",
					},
					operators: [
						{ type: "equal" },
						{ type: "not_equal" },
						{ type: "less" },
						{ type: "less_or_equal" },
						{ type: "greater" },
						{ type: "greater_or_equal" },
						{ type: "between" },
						{ type: "contains" },
						{ type: "not_contains" },
						{ type: "begins_with" },
						{ type: "ends_with" },
						{
							type: "is_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
						{
							type: "is_not_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
					],
				};

				console.log("rules")
				console.log(JSON.stringify(rules))
				if (Object.keys(rules).length > 0)
					config.rules = rules;

				console.log(config)

				try {
					$("#builder" + table.id).queryBuilder("destroy");
					if (!rules || rules.length == 0)
						self.request.tables[idx].conditions_qb_sql = "";
				} catch (err) {}

				$("#builder" + table.id).queryBuilder(config);

				$("#builder" + table.id).on(
					"change",
					function (e, rule, error, value) {
						console.log("change " + idx)
						try {
							self.request.tables[idx].conditions_qb_sql = $("#builder" + table.id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.request.tables[idx].conditions_qb = $("#builder" + table.id).queryBuilder(
								"getRules"
							);
							self.request.tables[idx].conditions_qb_sql = self.request.tables[idx].conditions_qb_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.request.tables[idx].conditions_qb_sql = self.request.tables[idx].conditions_qb_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							//console.log(self.rules_sql)
							//self.updatePage();
						} catch (err) {
							console.log(err)
							self.request.tables[idx].conditions_qb_sql = "";
						}
					}
				);

				$("#builder" + table.id).on(
					"afterDeleteRule.queryBuilder",
					function (e, rule, error, value) {
						console.log("delete " + idx)
						try {
							//self.rules = $('#builder').queryBuilder('getRules');
							console.log($("#builder" + table.id).queryBuilder(
								"getSQL",
								false
							))
							self.request.tables[idx].conditions_qb_sql = $("#builder" + table.id).queryBuilder(
								"getSQL",
								false
							).sql;
							//self.updatePage();
						} catch (err) {
							console.log(err)
							self.request.tables[idx].conditions_qb = "";
							self.request.tables[idx].conditions_qb_sql = "";
						}
					}
				);

				$("#builder" + table.id).on(
					"afterDeleteGroup.queryBuilder",
					function (e, group) {
						try {
							self.request.tables[idx].conditions_qb_sql = $("#builder" + table.id).queryBuilder(
								"getSQL",
								false
							).sql;
						} catch (err) {
							self.request.tables[idx].conditions_qb = "";
							self.request.tables[idx].conditions_qb_sql = "";
						}
					}
				);
			},

			async update_table(idx, update, update_name, event)
			{
				var table = event;

				console.log("update_table")
				console.log(this.tables[idx].name)
				console.log(table)
				console.log(idx)
				console.log(event)

				if (update_name)
					this.request.tables[idx].name = table;
				this.request.tables[idx].table = table;
				table = this.request.tables[idx];

				var prev_columns = {};
				if (update)
				{
					for (var i = 0; i < this.request.tables[idx].columns.length; i++)
					{
						prev_columns[this.request.tables[idx].columns[i].id] = this.request.tables[idx].columns[i];
					}
				}
				table.columns = [];

				console.log(table)
				console.log(table.table)

				var columns = await database.get("show", table.table);

				console.log("columns")
				console.log(columns)

				for (var i = 0; i < columns.length; i++)
				{
					console.log(columns[i])
					var column = {
						id: "`" + columns[i].Field + "`",
						column: columns[i].Field,
						label: columns[i].Field,
						name: table.table + "_" + columns[i].Field,
						type: columns[i].Type,
						select: true,
					};

					if (prev_columns[column.id])
					{
						column.name = prev_columns[column.id].name;
						column.select = prev_columns[column.id].select;
					}

					if (!(
						column.type == "string" ||
						column.type == "integer" ||
						column.type == "double" ||						
						column.type == "date" ||
						column.type == "time" ||
						column.type == "datetime" ||						
						column.type == "boolean"
					)) {
						switch (column.type) {
							case "int":
								column.type = "integer";
								break;
							case "float":
								column.type = "double";
								break;
							case "tinyint":
								column.type = "integer";
								break;
							case "tinyint":
								column.type = "integer";
								break;
							case "timestamp":
								column.type = "integer";
								break;
							default:
								column.type = "string";
						}
					}

					table.columns.push(column)
				}

				var lines = await database.get("SELECT", table.table, {
					end: "ORDER BY id DESC LIMIT 1",
				});

				if (lines && lines.length > 0)
				{
					for (var j = 0; j < table.columns.length; j++)
					{
						if (lines[0].hasOwnProperty(table.columns[j].column))
							this.$set(table.columns[j], "exemple", lines[0][table.columns[j].column]);
					}
				}

				this.$set(this.request.tables[idx], "_name", table.name);

				this.set_qb_table(table, idx);
			},
			async update_name(name, idx)
			{
				var table = this.request.tables[idx];

				console.log("update_name")
				console.log(JSON.stringify(table))

				for (var i = 0; i < table.columns.length; i++)
				{
					if (table.columns[i].name.startsWith(table._name + "_"))
						table.columns[i].name = name + table.columns[i].name.slice(table._name.length);
				}

				table._name = name;
			},
			async test()
			{
				var user_params = this.$refs.tp.get_obj();

				var response = await database.request(this.request, user_params);

				this.data_test = [];
				this.error = "";

				this.request.sql = response.sql;

				if (response.data)
				{
					this.data_test = response.data;
					this.$refs.tabulator.set_data(this.data_test);
				}
				if (response.error)
					this.error = response.error;
			},
			select_column_all(idx)
			{
				var table = this.request.tables[idx];

				for (var i = 0; i < table.columns.length; i++)
				{
					table.columns[i].select = true;
				}
			},
			unselect_column_all(idx)
			{
				var table = this.request.tables[idx];

				for (var i = 0; i < table.columns.length; i++)
				{
					table.columns[i].select = false;
				}
			},
			async add_prefix(idx)
			{
				var table = this.request.tables[idx];

				for (var i = 0; i < table.columns.length; i++)
				{
					if (!table.columns[i].name.startsWith(table.name + "_"))
						table.columns[i].name = table.name + "_" + table.columns[i].name;
				}
			},
			async remove_prefix(idx)
			{
				var table = this.request.tables[idx];

				for (var i = 0; i < table.columns.length; i++)
				{
					if (table.columns[i].name.startsWith(table.name + "_"))
						table.columns[i].name = table.columns[i].name.slice(table.name.length + 1);
				}
			},
		},
		mounted: async function () {
			
			var self = this;
			
			if (
				store.state.user.rules &&
				!store.state.user.rules.db_requests
			) {
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			if (this.client.details && this.client.details.tables)
				this.tables = this.client.details.tables;

			this.tables_name = []
			for (var i = 0; i < this.tables.length; i++)
			{
				this.tables_name.push(this.tables[i].name);
			}

			var element = document.getElementById(
				'builder-params-' + this.id
			);

			this.editor_params = new JSONEditor(element, {
				schema: {
					type: "array",
					title: "Paramètres",
					items: {
						type: "object",
						title: "Paramètre",
						properties: {
							value: {
								options: { hidden: true }
							},
							name: {
								type: "string",
								title: "Nom"
							},
							libelle: {
								type: "string",
								title: "Nom à afficher"
							},
							description: {
								type: "string",
								title: "Description"
							},
							required: {
								type: "boolean",
								format: "checkbox",
								title: "Obligatoire",
								default: true
							},
							dashboard: {
								type: "boolean",
								format: "checkbox",
								title: "Paramètre de tableau de bord",
								default: false
							},
							default: {
      							format: "textarea",
								title: "Valeur par défaut"
							},
							type: {
								title: "Type",
								type: "object",	
								oneOf: [
									{
										title: "Texte",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["texte"],
											},
											html_type: {
												title: "Type html",
												type: "string",
												enum: ["", "color", "date", "email", "month", "number", "password", "range", "tel", "time", "url", "week"]
											},
											datalist: {
												title: "Autocomplete",
												type: "array",
												format: "table",
												items: {
													type: "string",
													title: "Option"
												}
											},
											db: {
												title: "Liste autocomplete depuis la base de données",
												properties: {
													value: {
														title: "Clé",
														type: "string"
													},
													libelle: {
														title: "Valeur",
														type: "string"
													},
													table: {
														title: "Table",
														type: "string"
													},
													where: {
														title: "where",
														type: "string"
													},
													end: {
														title: "Fin de requête (limit, order by...)",
														type: "string"
													}
												}
											}
										},
									},
									{
										title: "Invisible",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["hidden"],
											}
										},
									},
									{
										title: "Vide",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["null"],
											}
										},
									},
									{
										title: "Zone de texte",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["textarea"],
											},
											rows: {
												title: "Nombre de lignes",
												type: "number",
												default: 5
											}
										},
									},
									{
										title: "Cases à cocher",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["checkbox"],
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														value: {
															title: "Clé",
															type: "string"
														},
														text: {
															title: "Valeur",
															type: "string"
														}
													}
												}
											}
										},
									},
									{
										title: "Option a sélectionner",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["radio"],
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														value: {
															title: "Clé",
															type: "string"
														},
														text: {
															title: "Valeur",
															type: "string"
														}
													}
												}
											}
										},
									},
									{
										title: "Liste",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["list"],
											},
											multiple: {
												title: "Choix multiples",
												type: "boolean",
												format: "checkbox"
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														value: {
															title: "Clé",
															type: "string"
														},
														text: {
															title: "Valeur",
															type: "string"
														},
													}
												}
											}
										},
									},
									{
										title: "Valeurs avec autocompletion",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["autocomplete"],
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														text: {
															title: "Valeur",
															type: "string"
														}
													}
												}
											}
										},
									},
									{
										title: "Drag&drop",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["draggable"],
											},
											datalist: {
												title: "Autocomplete",
												type: "array",
												format: "table",
												items: {
													type: "string",
													title: "Option"
												}
											}
										},
									},
									{
										title: "Drag&drop - liste",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["draggable_list"],
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														value: {
															title: "Clé",
															type: "string"
														},
														text: {
															title: "Valeur",
															type: "string"
														},
													}
												}
											}
										},
									}
								]
							}
						}
					}
				},
				object_background: "",
				keep_oneof_values: false,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				prompt_before_delete: false,
			});

			this.editor_params.on("change", function () {
				self.request.editor_params = self.editor_params.getValue();
				self.$refs.tp.set(self.request.editor_params);
			});
		},
	};
</script>
